import { Injectable } from "@angular/core";
import { DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyOperationsService {
  constructor(private powerSupplyService: DefaultService) {
  }

  getPowerSupplyOperationsList(powerSupplyId: number) {
    return this.powerSupplyService.getPowerSupplyOperationsList(powerSupplyId,null,null).pipe(map(result => result));
  }
}
